import React from 'react';
import { useFadeIn } from '../hooks/useFadeIn';
export function TestimonialsSection() {
  const fadeIn = useFadeIn();
  const testimonials = [{
    quote: 'Desde que tenemos el Pack 100 Citas, cada fin de semana se siente diferente. Ya no estamos todo el día con el celular. Hacemos los juegos, nos reímos, y siento que volví a conectar con mis hijos de verdad. Es el mejor regalo que nos hicimos como familia 💖.',
    author: 'Camila Godoy',
    role: 'mamá',
    stars: 5
  }, {
    quote: 'Con mi hijo siempre costaba encontrar tiempo para charlar. 100 Citas de Papá e Hijo nos dio la excusa perfecta para hacerlo. No solo hablamos, nos entendimos más. Es algo que todo padre debería vivir.',
    author: 'Martín Gutierrez',
    role: 'papá',
    stars: 5
  }, {
    quote: 'Compré el pack pensando que era algo simple, pero me sorprendió lo profundo que es. Cada cita tiene un sentido, una emoción. Mi hija espera con ilusión el momento de abrir una nueva página. ¡Nos unió más de lo que imaginé!',
    author: 'Laura Garcia',
    role: 'mamá',
    stars: 5
  }, {
    quote: 'Mi hijo siempre estaba con la tablet, y sentía que cada vez hablábamos menos. Desde que empezamos con 100 Citas con mi Hijo, tenemos nuestro "momento especial". Hacemos los desafíos, hablamos de todo y nos reímos muchísimo. No es solo un libro, es tiempo de calidad que nos hacía falta ❤️.',
    author: 'Romina D.',
    role: 'mamá',
    stars: 5
  }];
  return <section className="py-16 px-4 bg-white" data-id="element-223">
      <div className="max-w-3xl mx-auto" data-id="element-224">
        <div ref={fadeIn.ref} className={fadeIn.className} data-id="element-225">
          <div className="text-center mb-12" data-id="element-226">
            <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-4" data-id="element-227">
              💬 Lo que las familias dicen del Pack 100 Citas
            </h2>
            <div className="w-24 h-2 bg-yellow-400 mx-auto rounded-full" data-id="element-228"></div>
          </div>

          <div className="space-y-6" data-id="element-229">
            {testimonials.map((t, idx) => <div key={idx} className="bg-gray-50 p-6 md:p-8 rounded-2xl border border-gray-200 shadow-sm relative" data-id="element-230">
                <div className="absolute top-4 right-6 text-4xl text-gray-200 font-serif" data-id="element-231">
                  "
                </div>
                <div className="flex text-yellow-400 mb-3" data-id="element-232">
                  {[...Array(t.stars)].map((_, i) => <svg key={i} className="w-6 h-6 fill-current" viewBox="0 0 20 20" data-id="element-233">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-234" />
                    </svg>)}
                </div>
                <p className="text-xl md:text-2xl font-bold text-gray-800 mb-4 italic leading-relaxed relative z-10" data-id="element-235">
                  "{t.quote}"
                </p>
                <p className="text-gray-900 font-bold text-base" data-id="element-236">{t.author}</p>
                <p className="text-gray-600 text-sm" data-id="element-237">{t.role}</p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}